import './index_mWeb.css';
import SwipeableViews from 'react-swipeable-views';
import { RouteWrapper, TransactionHistoryTabBar, View } from '../../../component';
import DepositHistory from './deposit_history/index';
import WithdrawHistory from './withdraw_history/index';
import GameHistory from './game_history/index';
import PokerHistory from './poker_history/index';
import EarningHistory from './earning_history/index';
import NavigationHeader from '../../../component/navigation_header';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

interface Props {
  activeTab: any;
  onChangeTab: any;
  onChangeIndex: any;
  onClickBack: any;
  routes: any;
}
const TransactionHistoryMWeb = ({
  activeTab,
  onChangeIndex,
  onChangeTab,
  onClickBack,
  routes
}: Props) => {
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onClickBack} title={'Transaction History'} bgColor />
        {/* <HorizontalScrollView> */}
        <TransactionHistoryTabBar routes={routes} activeTab={activeTab} onChangeTab={onChangeTab} />
        {/* </HorizontalScrollView> */}
        <SwipeableViews style={{ height: '100%' }} index={activeTab} onChangeIndex={onChangeIndex}>
          <View className={'TH__tab_content__mWeb'}>{activeTab === 0 && <DepositHistory />}</View>
          <View className={'TH__tab_content__mWeb'}>{activeTab === 1 && <WithdrawHistory />}</View>
          <View className={'TH__tab_content__mWeb'}>{activeTab === 2 && <GameHistory />}</View>
          <View className={'TH__tab_content__mWeb'}>{activeTab === 3 && <PokerHistory />}</View>
          <View className={'TH__tab_content_earning'}>{activeTab === 4 && <EarningHistory />}</View>
        </SwipeableViews>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default TransactionHistoryMWeb;
